import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';



@Component
export class SiteHeader extends ThemeComponent {

    @Ref header!: HTMLDivElement;
    @Ref megaMenuTriggers!: HTMLDivElement[];
    @Ref backgroundOverlays!: HTMLDivElement[];
    @Ref megaMenuElements!: HTMLDivElement[];

    protected activeMegaMenu: HTMLDivElement|null = null;

    protected headerBounds: HeaderBounds = {
        top: 0,
        bottom: 0
    };

    protected currentScrollTop: number = 0;

    init() {
        this.createObserver();

        window.addEventListener('scroll', this.onScroll.bind(this), false);


        for (const megaMenuTrigger of this.megaMenuTriggers) {

            this.$listen(megaMenuTrigger, 'mouseover', (event) => {
                if (this.activeMegaMenu === null) {
                    this.megaMenuShow(event);
                }
            });

            this.$listen(megaMenuTrigger, 'mouseleave', (event) => {
                const clientWidth = document.body.clientWidth;
                if (clientWidth > 1024) {
                    this.megaMenuHide(event);
                }
            });
        }

        for (const backgroundOverlay of this.backgroundOverlays) {
            this.$listen(backgroundOverlay, 'click', (event) => {
                const clientWidth = document.body.clientWidth;
                if (this.activeMegaMenu !== null && clientWidth > 1024) {
                    this.activeMegaMenu.classList.remove('megamenu--visible');
                    setTimeout(() => {
                        this.activeMegaMenu = null;
                    }, 300);
                }
            });

            this.$listen(backgroundOverlay, 'mouseover', (event) => {
                if (this.activeMegaMenu !== null) {
                    this.activeMegaMenu.classList.remove('megamenu--visible');
                    setTimeout(() => {
                        this.activeMegaMenu = null;
                    }, 300);
                }
            });
        }

        for (const megaMenuElement of this.megaMenuElements) {
            this.$listen(megaMenuElement, 'mouseleave', (event) => {
                const clientWidth = document.body.clientWidth;

                if (this.activeMegaMenu !== null && clientWidth > 1024) {
                    this.activeMegaMenu.classList.remove('megamenu--visible');
                    setTimeout(() => {
                        this.activeMegaMenu = null;
                    }, 300);
                }
            });
        }
    }

    protected megaMenuShow(evt: Event) {
        const hoveredElement = evt.currentTarget as HTMLDivElement;
        this.activeMegaMenu = hoveredElement;
        hoveredElement.classList.add('megamenu--visible');
    }

    protected megaMenuHide(evt: Event) {
        const hoveredElement = evt.currentTarget as HTMLDivElement;
        hoveredElement.classList.remove('megamenu--visible');
        this.activeMegaMenu = null;
    }

    protected createObserver() {
        const observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    protected onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + this.header.offsetHeight)) {

            window.requestAnimationFrame(this.hide.bind(this));

        } else if ((scrollTop + 10) < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

            window.requestAnimationFrame(this.reveal.bind(this));

        } else if (scrollTop === 0) {
            window.requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    protected hide() {
        this.classList.add('header-hidden', 'header-sticky');
    }

    protected reveal() {
        const tabsNavigation = document.querySelector('.product-tabs-navigation');
        const clientWidth = document.body.clientWidth as number;
        if(tabsNavigation && clientWidth > 1024){
            return;
        }
        this.classList.add('header-sticky', 'animate');
        this.classList.remove('header-hidden');
    }

    protected reset() {
        this.classList.remove('header-hidden', 'header-sticky', 'animate');
    }
}
